import type { MessageDescriptor } from "@lingui/core";

import { msg } from "@lingui/core/macro";

import { FrequencyUnit } from "../../api";

export const frequencyUnits: Record<FrequencyUnit, MessageDescriptor> = {
  [FrequencyUnit.days]: msg`days`,
  [FrequencyUnit.months]: msg`months`,
};

/**
 * The unit of a medication's repeat interval, defaulting to days — the API's
 * own default, and what every row stored before the unit existed means.
 */
export function frequencyUnitOf(row: {
  medication_frequency_regular_repeat_every_unit?: FrequencyUnit | null;
}): FrequencyUnit {
  return (
    row.medication_frequency_regular_repeat_every_unit ?? FrequencyUnit.days
  );
}

/**
 * The interval a unit change has to travel with. The API rejects a request
 * that changes the unit without naming the interval it applies to
 * (`UNIT_NEEDS_ITS_COUNT`, Seerlinq/db-api#744), and a patch carries only the
 * fields that changed — so touching the unit selector alone would be a 422.
 * Resending the interval the row already holds is a no-op there.
 *
 * Only a patch that carries a unit gets it: the interval of a day-scheduled
 * row is inert, and sending it would leave the merged row with two
 * frequencies — a 422 of its own.
 */
export function applyFrequencyUnitCountToPatch(
  patch: Record<string, unknown>,
  row: { medication_frequency_regular_repeat_every?: number | null },
) {
  if (
    !("medication_frequency_regular_repeat_every_unit" in patch) ||
    "medication_frequency_regular_repeat_every" in patch
  ) {
    return patch;
  }

  return {
    ...patch,
    medication_frequency_regular_repeat_every:
      row.medication_frequency_regular_repeat_every,
  };
}
